import {WhitelabelEventWithPayload} from "../../../../common/ts/events/Events";

interface SortingOptionSelectedPayload {
    optionValue: string | undefined,
    currentUrl: string,
}

export class SortingOptionSelectedEvent implements WhitelabelEventWithPayload<SortingOptionSelectedPayload> {
    payload: SortingOptionSelectedPayload;
    type: string;
    static readonly TYPE: string = 'sorting-option-selected';

    constructor(payload: SortingOptionSelectedPayload) {
        this.type = SortingOptionSelectedEvent.TYPE;
        this.payload = payload;
    }
}
